import { generateImagePath } from '@/plugins/imagePath';
import { get, post } from '@/utils/api';
import { setThemeContent } from '@/utils/initialLoad';
import { getFocalPointString } from '@/utils/focalPointTools';

export const processors = {
	backgroundImage: (fileId, opts = []) => `url(${generateImagePath(parseInt(fileId, 10), false, undefined, opts.includes('breakCache'))});${getFocalPointString(parseInt(fileId, 10), false, false)}`
};

export function splitIntermediateValue(data)
{
	const [, intermediate] = data.split(/##/m);
	let key,
		value;

	if(intermediate)
	{
		[key, value] = intermediate.split('|');
	}

	return { key, value };
}

// opts should be an object, with option names as keys, and arrays of intermediate values as values
export function processStyles(data, opts = {})
{
	if(!data)
	{
		data = '';
	}

	const dataArray = data.split(/##/m);

	return dataArray.reduce((agg, string) =>
	{
		if(string.split('|').length !== 2)
		{
			agg += string;
		}
		else
		{
			const [type, value] = string.split('|');
			const options = Object.entries(opts).reduce((agg, [option, applyToValues]) =>
			{
				if(applyToValues.includes(value))
				{
					agg.push(option);
				}

				return agg;
			}, []);

			if(!processors[type])
			{
				console.error(`No processor exists for type ${type}`);
			}
			else
			{
				const updated = processors[type](value, options);

				agg += updated;
			}
		}

		return agg;
	}, '');
}

export function getIntermediateValues(data, types)
{
	const dataArray = data.split(/##/m);

	return dataArray.reduce((agg, string) =>
	{
		if(string.split('|'.length === 2))
		{
			const [type, value] = string.split('|');

			if(types.includes(type))
			{
				agg.push({ type, value });
			}
		}

		return agg;
	}, []);
}

export async function reloadStyles(opts)
{
	const { data } = await get('service/theme.css');
	const processedTheme = processStyles(data, opts);

	setThemeContent(processedTheme);
}

/**
 * @param {string} theme
 * @returns {void}
 */
export function insertTheme(theme)
{
	const style = document.createElement('style');

	style.id = 'custom-style';

	style.setAttribute('type', 'text/css');

	const processedTheme = processStyles(theme);

	if(document.head)
	{
		document.head.insertAdjacentElement('beforeend', style);
		setThemeContent(processedTheme);
	}
}

/**
 * @param {object} ctx
 * @param {number=} ctx.brandId
 * @returns {Promise<string>}
 */
export async function getBrandTheme({ brandId } = {})
{
	let url = 'service/brands/active/theme.css';

	if(brandId)
	{
		url = `service/brands/${brandId}/theme.css`;
	}

	const { data } = await get(url);

	return data;
}

/**
 * @returns {Promise<string>}
 */
export async function getBlankTheme()
{
	const url = 'service/brands/default/theme.css';

	return get(url).then(({ data: theme }) =>
	{
		return theme;
	});
}

/**
 * @param {object} ctx
 * @param {number=} ctx.brandId
 * @returns {Promise<ResSuccess>}
 * @throws {ResErrorAxios}
 */
export async function getThemeStyles({ brandId } = {})
{
	let path = 'service/brands/active/getThemeStyles';

	if(brandId)
	{
		path = `service/brands/${brandId}/getThemeStyles`;
	}

	const { data } = await post(path);

	return data;
}
